import T from 'prop-types';
import styled from 'styled-components';
import { unit } from '../../styles/unit';
import { resetButtonStyleWithTransition } from '../../styles/mixins';
const NavigationButton = /*#__PURE__*/styled.button.attrs(props => ({
  as: props.as || (props.href ? 'a' : 'button')
})).withConfig({
  displayName: "NavigationButton",
  componentId: "sc-69mqjk-0"
})(["", ";padding:0 ", ";border:0;white-space:nowrap;background-color:transparent;&:hover{text-decoration:none;}"], resetButtonStyleWithTransition, unit(3));
NavigationButton.propTypes = {
  href: T.string,
  children: T.node
};
export { NavigationButton };